import { render } from "./Services.vue?vue&type=template&id=7ab52cce&scoped=true"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"

import "./Services.vue?vue&type=style&index=0&id=7ab52cce&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7ab52cce"

export default script